var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875 11.375C0.875 11.2092 0.940848 11.0503 1.05806 10.9331C1.17527 10.8158 1.33424 10.75 1.5 10.75H14C14.1658 10.75 14.3247 10.8158 14.4419 10.9331C14.5592 11.0503 14.625 11.2092 14.625 11.375C14.625 11.5408 14.5592 11.6997 14.4419 11.8169C14.3247 11.9342 14.1658 12 14 12H1.5C1.33424 12 1.17527 11.9342 1.05806 11.8169C0.940848 11.6997 0.875 11.5408 0.875 11.375ZM0.875 6.375C0.875 6.20924 0.940848 6.05027 1.05806 5.93306C1.17527 5.81585 1.33424 5.75 1.5 5.75H14C14.1658 5.75 14.3247 5.81585 14.4419 5.93306C14.5592 6.05027 14.625 6.20924 14.625 6.375C14.625 6.54076 14.5592 6.69973 14.4419 6.81694C14.3247 6.93415 14.1658 7 14 7H1.5C1.33424 7 1.17527 6.93415 1.05806 6.81694C0.940848 6.69973 0.875 6.54076 0.875 6.375ZM0.875 1.375C0.875 1.20924 0.940848 1.05027 1.05806 0.933058C1.17527 0.815848 1.33424 0.75 1.5 0.75H14C14.1658 0.75 14.3247 0.815848 14.4419 0.933058C14.5592 1.05027 14.625 1.20924 14.625 1.375C14.625 1.54076 14.5592 1.69973 14.4419 1.81694C14.3247 1.93415 14.1658 2 14 2H1.5C1.33424 2 1.17527 1.93415 1.05806 1.81694C0.940848 1.69973 0.875 1.54076 0.875 1.375Z",
    fill: "color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList2);
export default __webpack_public_path__ + "static/media/list_2.3c5aa0d454656497170818338759c2b1.svg";
export { ForwardRef as ReactComponent };